import { parsePhoneNumber } from 'react-phone-number-input';

export function displayPhoneNumber(value?: string | null): string {
  if (!value) return '—';
  return parsePhoneNumber(value, 'US')?.formatNational() || value;
}
